import React, { useState, Dispatch, SetStateAction } from "react";
import Typography from "@mui/material/Typography";
import InsightFiltersViewModel from "../../../ViewModels/InsightFiltersViewModel";
import FilterChipDisplay from "../../../../Filtering/FilterChipDisplay";
import AutoCompleteFilterDialog from "./AutoCompleteFilterDialog";

interface IAutoCompleteFilterContainerProps {
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
    name: string
    label: string
    options: string[]
}

export default function AutoCompleteFilterContainer({ filters, setFilters, name, label, options }: IAutoCompleteFilterContainerProps) {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const text = <Typography variant='body1'>{`${label}: ${filters[name]}`}</Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setIsDialogOpen(true)} />
            <AutoCompleteFilterDialog
                open={isDialogOpen}
                setOpen={setIsDialogOpen}
                filters={filters}
                setFilters={setFilters}
                name={name}
                label={label}
                options={options} />
        </>
    );
};
